import { onMounted, computed, ref } from "vue";
import { UserManager, WebStorageStateStore, User } from "oidc-client-ts";
import { Log, settings } from "@/oidc/settings";

const userManager = new UserManager({
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  ...settings,
});

export function useAuthManager() {
  const userInfo = ref({});
  const expiringDate = computed(() => {
    if (userInfo.value?.expires_at) {
      return new Date(userInfo.value?.expires_at * 1000);
    }
    return null;
  });
  const isSignedIn = computed(() => {
    return !!userInfo.value?.access_token && !!userInfo.value?.expires_at < new Date().getTime() / 1000;
  });

  async function replaceUser(newUser) {
    const usr = new User(newUser);
    await userManager.storeUser(usr);
  }

  return { userInfo, expiringDate, userManager, isSignedIn, replaceUser };
}
